<template>
  <v-row justify="center"
    v-if="!isSimulation && showCookiePolicy"
  >
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          text
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn>
      </template>
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ $t('settings.formTerms.cookiePolicy') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false"
            >
              OK
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
  <vue-editor 
    v-model="cookiePolicy"
    :disabled="true"
    :editor-toolbar="aux"
  />
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
const minToolbar = [[],[],[],[],[],[],[],[],[],[],[],[],[{  }],[]]
import { VueEditor } from 'vue2-editor'
import constants from '@/constants'
import utilsService from '@/services/utils'
import api from '@/services/api'
export default {
  components: {
    VueEditor,
  },
  props: {
    workspaceID: {
      type: String,
      requried: true,
    },
    locale: {
      type: String,
      default: 'es',
    },
  },
  data: () => ({
    loading: false,
    showCookiePolicy: false,
    cookiePolicy: null,
    aux: minToolbar,
  }),
  computed: {
    isSimulation () {
      return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
    },
  },
  watch: {
    workspaceID () {
      this.handleGetData()
    },
    locale () {
      this.handleGetData()
    },
  },
  mounted () {
    this.handleGetData()
  },
  methods: {
    handleGetData () {
      api.getAll(`enterprises/terms/${this.workspaceID}`, false, 1, 100000, '')
        .then(response => {
          if (!response || response.length === 0) return
          const aux = response.shift()
          this.showCookiePolicy = aux.ShowCookiePolicy ? true : false
          this.cookiePolicy = aux.CookiePolicy ? utilsService.getTranslation(JSON.parse(aux.CookiePolicy), this.locale) : null 
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
  },
}
</script>

